import { createAction, props } from '@ngrx/store';

import { TailBiting } from '../../model/tail-biting.model';
import { UpsertTailBitingResponse } from '../../services/tail-biting-service.model';

export const loadData = createAction('[TailBiting] Load Data');
export const clearTailBitingState = createAction('[TailBiting] Clear State');
export const clearSelectedTailBiting = createAction('[TailBiting] Clear Selected TailBiting');

export const setSelectedTailBitingRequest = createAction(
  '[TailBiting] Set Selected TailBiting Request',
  props<{ id: number }>(),
);
export const setSelectedTailBitingSuccess = createAction(
  '[TailBiting] Set Selected TailBiting Success',
  props<{ tailBiting: TailBiting }>(),
);
export const setSelectedTailBitingError = createAction(
  '[TailBiting] Set Selected TailBiting Error',
  props<{ error: Error }>(),
);

export const getTailBitingsRequest = createAction('[TailBiting] Get TailBitings Request');
export const getTailBitingsSuccess = createAction(
  '[TailBiting] Get TailBitings Success',
  props<{ tailBitings: TailBiting[] }>(),
);

export const getTailBitingsError = createAction(
  '[TailBiting] Get TailBitings Error',
  props<{ error: Error }>(),
);

export const upsertTailBitingRequest = createAction(
  '[TailBiting] Upsert TailBiting Request',
  props<{ request: TailBiting }>(),
);
export const upsertTailBitingSuccess = createAction(
  '[TailBiting] Upsert TailBiting Success',
  props<{ request: TailBiting; response: UpsertTailBitingResponse }>(),
);
export const upsertTailBitingError = createAction(
  '[TailBiting] Upsert TailBiting Error',
  props<{ error: Error }>(),
);

export const deleteTailBitingRequest = createAction(
  '[TailBiting] Delete TailBiting Request',
  props<{ tailBiting: TailBiting }>(),
);
export const deleteTailBitingWithConfirmation = createAction(
  '[TailBiting] Confirm Delete TailBiting',
  props<{ tailBiting: TailBiting }>(),
);
export const deleteTailBitingSuccess = createAction(
  '[TailBiting] Delete TailBiting Success',
  props<{ tailBitingId: number }>(),
);

export const navigateCreateTailBiting = createAction(
  '[TailBiting] Navigate to create tailbiting',
  props<{ locationId: number }>(),
);
